import { storyblokEditable } from "@storyblok/react/rsc";
import { clsx } from "clsx";
import Image from "next/image";
import Link from "next/link";

import type { ImageTeaserStoryblok } from "@/component-types-sb";
import { Button } from "@/components/layout/Button";
import { BodyText } from "@/components/typography";
import { getUrlFromLinkObject } from "@/lib/storyblok/utils";
import imageLoader from "@/lib/utils/imageLoader";

type ImageTeaserProps = {
  blok: ImageTeaserStoryblok;
};

const ImageTeaser = ({ blok }: ImageTeaserProps) => {
  const href = getUrlFromLinkObject(blok.link);

  return (
    <section className="flex flex-col gap-4" {...storyblokEditable(blok)}>
      <Image
        className={clsx("object-cover w-full h-64 aspect-square", {
          "order-last": blok.reverse,
        })}
        loader={imageLoader}
        src={blok.image?.filename || ""}
        width={300}
        height={300}
        sizes="20vw"
        alt={blok.image?.alt || ""}
      />

      <h2 className="text-2xl text-brand-primary100 font-bold">
        {blok.headline}
      </h2>

      <BodyText className="max-w-md mx-auto mt-2">{blok.text}</BodyText>

      {href && (
        <Link href={href || "#"} target={blok.link?.target}>
          <Button colorScheme="primary" className="my-2">
            {blok.label}
          </Button>
        </Link>
      )}
    </section>
  );
};

export default ImageTeaser;
